import { t } from '@lingui/core/macro';
import { AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { StyledButton } from './styled';
export function DocumentName(props) {
    const { locked, name, onClick } = props;
    const ariaLabel = t `Contract template is not available for the current plan.`;
    return (<StyledButton type="button" onClick={onClick}>
      <AvatarWithLabel truncate shape="square" size="sm" appearance={locked ? 'info' : 'light'} title={name}>
        {locked ? <Falcon data-testid="locked-icon" aria-label={ariaLabel} icon="lock-alt"/> : <Falcon icon="file"/>}
      </AvatarWithLabel>
    </StyledButton>);
}
